import { useState } from 'react';
import { FaRegStar } from 'react-icons/fa';
import { FiSmile } from 'react-icons/fi';
import { PiArrowBendUpLeftBold } from 'react-icons/pi';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import { FiMinimize } from 'react-icons/fi';
import { BiCollapseVertical, BiExpandVertical } from 'react-icons/bi';
import { TbBaselineDensitySmall } from 'react-icons/tb';

import EmailIframe from '../chat/EmailIframe';
import EmailContent from './EmailContent';
import { convertToIST } from '../../utils/dateTimeUtils';

export default function EmailConversation({
  outlookEmailThread,
  setLoading,
  loading,
}) {
  const [expanded, setExpanded] = useState(false);
  const [openEmail, setOpenEmail] = useState(null);

  const [isAnalyticsView, setIsAnalyticsView] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const visibleCount = 3;

  const toggleView = () => {
    setIsAnalyticsView(!isAnalyticsView);
  };

  const visibleEmails = expanded
    ? outlookEmailThread
    : outlookEmailThread.length > 4
      ? [outlookEmailThread[0], 'expand', ...outlookEmailThread.slice(-2)]
      : outlookEmailThread;

  return (
    <div className="mx-auto w-full p-4 pl-0 pr-0 ">
      <div className="text-md flex items-center gap-2 p-4 pl-0 font-semibold text-gray-800">
        <TbBaselineDensitySmall size={20} /> Conversation Thread
      </div>
      <div className="divide-y divide-gray-300 rounded-md border border-gray-300 ">
        {visibleEmails.map((email, index) =>
          email === 'expand' ? (
            <button
              key={index}
              onClick={() => setExpanded(true)}
              className="relative flex w-full items-center justify-center p-2 text-center text-blue-600 transition-all hover:underline"
            >
              {/* Show {outlookEmailThread.length - 3} more <HiChevronDown size={16} /> */}
              <div className="absolute rounded-full border border-gray-400 bg-gray-100 p-2 text-gray-400 hover:border-gray-600 hover:bg-gray-200 hover:text-gray-600">
                <BiExpandVertical size={20} />
              </div>
            </button>
          ) : (
            // eslint-disable-next-line
            <div
              key={email.id}
              className="cursor-pointer  p-3 transition-all duration-300 ease-in-out"
              onClick={() =>
                setOpenEmail(openEmail === email.id ? null : email.id)
              }
            >
              {!(openEmail === email.id) ? (
                <div className="flex items-center  justify-between transition-all duration-300 ease-in-out ">
                  <div className="flex items-center">
                    <div className="flex h-10 w-10  items-center justify-center rounded-full bg-gray-700 text-sm font-bold text-white">
                      {email.sender?.name?.[0]?.toUpperCase() ?? '?'}
                    </div>
                    <div className="ml-3 text-gray-800">
                      {email?.sender?.name}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-500">
                      {convertToIST(email?.date).date || ''}
                    </span>
                    <span className="text-sm text-gray-500">
                      {convertToIST(email?.date).time || ''}
                    </span>
                    <button className="ml-4 flex items-center text-gray-500 hover:text-gray-700 ">
                      <FaRegStar />
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  {/* eslint-disable-next-line */}
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="mt-4 flex w-full flex-row transition-all duration-300 ease-in-out"
                  >
                    <div className="px-4 pl-0">
                      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-700 text-sm font-bold text-white">
                        {email.sender?.name?.[0]?.toUpperCase() ?? '?'}
                      </div>
                    </div>
                    <div className="flex w-full flex-col">
                      <div className="flex items-center justify-between">
                        <div className="mb-4 flex items-center text-gray-700">
                          <div className="flex flex-col">
                            <span className="font-semibold">
                              {/* {email.from?.name} */}
                              <span className="text-sm font-normal text-gray-500">
                                {email.from.contact || 'No Sender'}
                              </span>
                            </span>

                            <div className="flex">
                              {!loading && (
                                <span className="mr-2 text-gray-500"> to </span>
                              )}
                              <div className="flex items-center">
                                {email.to
                                  ?.slice(0, visibleCount)
                                  .map((to, index) => (
                                    <span
                                      key={to?.email || to?.name || index}
                                      className="font-semibold"
                                      title={to?.email || 'No Recipient'}
                                    >
                                      {to?.name || to?.email || 'No Recipient'}
                                      {index <
                                        Math.min(
                                          visibleCount,
                                          email.to?.length,
                                        ) -
                                          1 && ', '}
                                    </span>
                                  ))}

                                {/* Toggle button to expand/collapse extra recipients */}
                                {email.to?.length > visibleCount && (
                                  <button
                                    className="ml-1 flex items-center text-[#5652CF] hover:underline"
                                    onClick={() => setShowAll(!showAll)}
                                  >
                                    {showAll
                                      ? 'show less'
                                      : `+${email.to?.length - visibleCount}`}
                                    {showAll ? (
                                      <HiChevronUp size={14} />
                                    ) : (
                                      <HiChevronDown size={14} />
                                    )}
                                  </button>
                                )}
                              </div>

                              {/* Extra emails, smoothly expanding below */}
                              <div
                                className={`rounded-xl border border-gray-400 p-2 font-semibold text-gray-500 transition-all duration-300 ease-in-out ${
                                  showAll
                                    ? 'max-h-40 opacity-100'
                                    : 'max-h-0 overflow-hidden opacity-0'
                                }`}
                              >
                                {email.to
                                  ?.slice(visibleCount)
                                  .map((to, index) => (
                                    <span
                                      key={to?.email || to?.name || index}
                                      className="block text-sm text-gray-700"
                                    >
                                      {to?.name || to?.email || 'No Recipient'}
                                    </span>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mr-4 flex flex-col gap-2 text-sm">
                          <div className="flex gap-3">
                            <div className="mb-2 flex items-center gap-2">
                              <button
                                className={`flex items-center justify-center rounded px-3 py-1 text-xs text-white transition ${
                                  loading
                                    ? 'h-4 w-14 animate-pulse bg-gray-300'
                                    : 'bg-zinc-500 hover:bg-zinc-600'
                                }`}
                                onClick={toggleView}
                                disabled={loading}
                              >
                                {loading
                                  ? ''
                                  : isAnalyticsView
                                    ? 'View Email'
                                    : 'AI View'}
                              </button>
                              {!loading ? (
                                <span className="text-sm text-gray-500">
                                  {convertToIST(email?.date).date || ''}
                                </span>
                              ) : (
                                <div className="h-3 w-3/4 animate-pulse rounded bg-gray-500"></div>
                              )}
                            </div>
                            <div className="mb-2 flex items-center">
                              {!loading ? (
                                <span className="text-sm text-gray-500">
                                  {convertToIST(email?.date).time || ''}
                                </span>
                              ) : (
                                <div className="h-3 w-3/4 animate-pulse rounded bg-gray-300"></div>
                              )}
                            </div>
                            <button className="mb-2 text-gray-500 hover:text-gray-700">
                              <FaRegStar />
                            </button>
                            <button className="mb-2 text-gray-500 hover:text-gray-700">
                              <FiSmile />
                            </button>
                            <button className="mb-2 text-gray-500 hover:text-gray-700">
                              <PiArrowBendUpLeftBold />
                            </button>
                            <button
                              onClick={() =>
                                setOpenEmail(
                                  openEmail === email.id ? null : email.id,
                                )
                              }
                              className="mb-2 text-gray-500 hover:text-gray-700"
                            >
                              <BiCollapseVertical size={15} />
                            </button>
                            <button className="mb-2 text-gray-500 hover:text-gray-700">
                              <BsThreeDotsVertical />
                            </button>
                          </div>
                          <div className="mb-2 flex justify-end">
                            <span
                              className={`rounded-md px-3 py-1 text-xs font-semibold text-white 
                                  ${
                                    email?.priority === 1 ||
                                    email?.priority === 0
                                      ? 'bg-blue-400'
                                      : email?.priority >= 2 &&
                                          email?.priority <= 3
                                        ? 'bg-yellow-400'
                                        : email?.priority >= 4
                                          ? 'bg-red-400'
                                          : 'bg-gray-500'
                                  }`}
                            >
                              {email?.priority === 1 || email?.priority === 0
                                ? 'Low'
                                : email?.priority >= 2 && email?.priority <= 3
                                  ? 'Medium'
                                  : email?.priority >= 4
                                    ? 'High'
                                    : 'Unknown'}
                            </span>
                          </div>
                        </div>
                      </div>
                      <EmailContent
                        email={email}
                        loading={loading}
                        isAnalyticsView={isAnalyticsView}
                        messageId={email?.message_id}
                        isDialog={true}
                        isOutlook={true}
                        setIsFullScreen={setIsFullScreen}
                        isConversationThread={true}
                      />
                    </div>
                  </div>

                  {isFullScreen && (
                    <div className="fixed inset-0 z-50 h-screen w-screen bg-white p-6 transition-all duration-300 ease-in-out">
                      {/* Close button stays fixed at top-right */}
                      <button
                        className="absolute bottom-8 right-14 mb-4 transform rounded-full bg-gray-200 p-2 text-gray-500 transition-all hover:scale-110 hover:bg-gray-300 hover:text-gray-700"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsFullScreen(false);
                        }}
                      >
                        <FiMinimize size={24} />
                      </button>

                      {/* Scrollable content */}
                      {/* eslint-disable-next-line */}
                      <div
                        onClick={(e) => e.stopPropagation()}
                        className="scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200 h-full overflow-auto"
                      >
                        {/* <article
                              dangerouslySetInnerHTML={{ __html: email.body }}
                              className="text-gray-700 min-h-60 flex items-center justify-center whitespace-pre-line"
                            /> */}
                        <EmailIframe emailBody={email.body}></EmailIframe>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          ),
        )}
      </div>
      {expanded && (
        <button
          onClick={() => setExpanded(false)}
          className="mt-3 flex w-full items-center justify-center text-blue-600 transition-all duration-300 ease-in-out hover:underline"
        >
          <div className="rounded-full border border-gray-400 p-2 text-gray-400 hover:border-gray-600 hover:bg-gray-200 hover:text-gray-600">
            <BiCollapseVertical size={20} />
          </div>
        </button>
      )}
    </div>
  );
}
